import React from 'react';
import './Loader.css';

/**
 * Un componente simple para mostrar un spinner animado y un mensaje opcional.
 * @param {object} props
 * @param {string} [props.message] - El mensaje a mostrar debajo del spinner.
 * @param {boolean} [props.isOverlay] - Si true, muestra el loader como overlay bloqueando toda la pantalla.
 */
const Loader = ({ message, isOverlay = false }) => {
  return (
    <div className={`loader-container ${isOverlay ? 'loader-overlay' : ''}`}>
      <div className="loader-content">
        <div className="loader-spinner"></div>
        {message && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;